import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export interface Relationship {
  adviserId: number;
  firstName: string;
  lastName: string;
  isOwner: boolean;
  isManager: boolean;
  isRemovable: boolean;
}

export interface CampaignAccessDTO {
  canTransferOwnership: boolean;
  relationships: Relationship[];
}

interface FetchCampaignAccessParams {
  campaignId?: string;
}

const fetchCampaignAccess = async ({
  campaignId,
}: FetchCampaignAccessParams): Promise<CampaignAccessDTO> => {
  return authFetch(`/Adviser/Campaigns/Access/${campaignId}`);
};

interface CampaignAccessQueryParams {
  campaignId?: string;
  onSuccess(campaignAccess: CampaignAccessDTO): void;
}

export const useCampaignAccessQuery = ({ campaignId, onSuccess }: CampaignAccessQueryParams) => {
  return useQuery(
    queryKeys.campaignAccess(campaignId),

    () => fetchCampaignAccess({ campaignId }),

    {
      cacheTime: 0,
      onSuccess,
      enabled: !!campaignId,
    },
  );
};
